import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
//import axios from "axios";
// import editIcon from "./../assets/edit.png";
// import deleteIcon from "./../assets/delete.JPG";
import "../App.css";
import {AgGridReact} from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

import NSEActionRenderer from './NSEActionRenderer';

import { Line } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import 'chartjs-plugin-trendline';
Chart.register(...registerables);


const NSEDataTable = () => {

const gridRef = useRef();


const updateChartFromGrid = () => {
  const api = gridRef.current?.api;
  if (!api) return;
  const filteredRows = [];
  api.forEachNodeAfterFilter(node => {
    filteredRows.push(node.data);
  });
  const labels = filteredRows.map(item => {
    const date = new Date(item.nsedate);
    return isNaN(date.getTime()) ? item.nsedate : date.toLocaleDateString();
  });
  const closeValues = filteredRows.map(item => item.nseclose);

  // Scatter data: array of {x, y}
  const buyScatter = filteredRows.map((item, i) => ({
    x: labels[i],
    y: item.nsebuy
  }));
  const sellScatter = filteredRows.map((item, i) => ({
    x: labels[i],
    y: item.nsesell
  }));

  setChartData({
    labels: labels,
    datasets: [
      {
        label: 'Close',
        data: closeValues,
        borderColor: 'rgba(75, 192, 192, 1)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        fill: false,
        yAxisID: 'y',
        type: 'line',
        trendlineLinear: {
          style: "rgba(255,105,180, .8)",
          lineStyle: "solid",
          width: 2
        }
      },
      {
        label: 'Buy',
        data: buyScatter,
        borderColor: 'rgba(255, 99, 132, 1)',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        fill: false,
        yAxisID: 'y1',
        type: 'scatter',
        showLine: false
      },
      {
        label: 'Sell',
        data: sellScatter,
        borderColor: 'rgba(54, 162, 235, 1)',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        fill: false,
        yAxisID: 'y1',
        type: 'scatter',
        showLine: false
      }
    ],
  });
};

  const navigate = useNavigate();
  const baseURL = "https://nseapi.maclogi.com/api/";
  //const baseURL = "http://localhost:3000/api/";

  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


//AG-GRID============================================
  // const [rowData, setRowData] = useState([
  //   {labels:'',  values:''}
  // ]);


  // const [columnDefs,setColumnDefs] = useState([
    
  //   {field:'nsedate', headerName:'Date', sortable: true, filter: true, cellEditor: "MyEditor"},
  //   {field:'nseclose', headerName:'Close', sortable: true, filter: true},
  // ])

  
  const [rowData, setRowData] = useState([
    {nseid:'', nsedate:'', nseopen:'', nsehigh:'', nselow:'', nseclose:'', nsebuy:'', nsesell:''}
  ]);


  const [columnDefs, setColumnDefs] = useState([
    {field:'nseid', headerName:'Id', sortable: true, filter: true, cellRenderer: NSEActionRenderer, flex: 1},
    {
      field:'nsedate',
      headerName:'Date',
      sortable: true,
      filter: 'agDateColumnFilter',
      valueFormatter: params => {
        const date = new Date(params.value);
        return isNaN(date.getTime()) ? params.value : date.toLocaleDateString();
      },
      filterParams: {
        comparator: function(filterLocalDateAtMidnight, cellValue) {
          const cellDate = new Date(cellValue);
          if (isNaN(cellDate.getTime())) return -1;
          if (cellDate.setHours(0,0,0,0) < filterLocalDateAtMidnight.getTime()) return -1;
          if (cellDate.setHours(0,0,0,0) > filterLocalDateAtMidnight.getTime()) return 1;
          return 0;
        }
      },
      flex: 1
    },
    {field:'nseopen', headerName:'Open', sortable: true, filter: true, flex: 1},
    {field:'nsehigh', headerName:'High', sortable: true, filter: true, flex: 1},
    {field:'nselow', headerName:'Low', sortable: true, filter: true, flex: 1},
    {field:'nseclose', headerName:'Close', sortable: true, filter: true, flex: 1},
    {field:'nsebuy', headerName:'Buy', sortable: true, filter: true, flex: 1},
    {field:'nsesell', headerName:'Sell', sortable: true, filter: true, flex: 1}
  ])




// useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch('https://nseapi.maclogi.com/api/nses');
//         //const response = await fetch('http://localhost:3000/api/nses');

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const data = await response.json(
          
//         );

        
//         const labels = data.map((item) => item.nsedate);
//         const values = data.map((item) => item.nseclose);

        

//         setChartData({
//           labels: labels,
//           datasets: [
//             {
//               label: 'Date',
//               data: values,
//               borderColor: 'rgba(75, 192, 192, 1)',
//               fill: false,
//             },
//           ],
//         });


//       } catch (e) {
//         setError(e);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);



  useEffect(() => {
    fetch(baseURL + "nses")
      .then(result => result.json()) 
      .then(rowData => {
        console.log(rowData); // Debug
        setRowData(rowData);
      })
  }, []);

  useEffect(() => {
  if (gridRef.current && rowData && rowData.length > 0) {
    updateChartFromGrid();
  }
}, [rowData]);

const AddNSEClicked = () => {
  navigate('/addnse');
}

const handleChartClick = (event, elements) => {
  if (!elements.length) return;
  const chart = elements[0];
  const clickedIndex = chart.index;
  const clickedLabel = chartData.labels[clickedIndex];

  // Find the row in rowData with matching formatted date
  const match = rowData.find(row => {
    const date = new Date(row.nsedate);
    const formatted = isNaN(date.getTime()) ? row.nsedate : date.toLocaleDateString();
    return formatted === clickedLabel;
  });

  if (match && gridRef.current) {
    gridRef.current.api.forEachNode(node => {
      if (node.data === match) {
        node.setSelected(true);
        gridRef.current.api.ensureNodeVisible(node);
      } else {
        node.setSelected(false);
      }
    });
  }
};

// console.log("rowData:", rowData);
// console.log("columnDefs:", columnDefs);

  return (
  <div style={{width: '100%', maxWidth: 1200, margin: '0 auto', padding: 16}}>
    <button onClick={AddNSEClicked} style={{marginBottom: 12}}>Add New NSE</button>
    <div className='ag-theme-alpine' style={{height: 90, width: '100%'}}>
      <AgGridReact
        ref={gridRef}
        animateRows={true}
        rowData={rowData}
        columnDefs={columnDefs}
        rowSelection="single"
        onFilterChanged={updateChartFromGrid}
        onGridReady={updateChartFromGrid}
      />
    </div>
    <div style={{height: 460, width: '100%', marginTop: 24}}>
      {chartData && (
        <Line
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: true },
            },
            scales: {
              y: {
                type: 'linear',
                display: true,
                position: 'left',
                title: { display: true, text: 'Close' }
              },
              y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: { drawOnChartArea: false },
                title: { display: true, text: 'Buy/Sell' }
              }
            },
            onClick: (event, elements) => handleChartClick(event, elements),
          }}
          style={{height: '100%', width: '100%'}}
        />
      )}
    </div>
  </div>
  );

//AG-GRID============================================
}

export default NSEDataTable;